exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item-checkbox[data-v-37392c90]{\n  padding-left: 20px;\n}\n", ""]);

// exports
